module.exports = __webpack_public_path__ + "h5/img/master_12.e017fee5.jpg";